import React from 'react';
import { observer, inject } from 'mobx-react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { CircularProgress } from '@material-ui/core';
import { Redirect } from 'react-router';
import { createComponent as cc } from 'react-fela';

import Home from './home';
import Login from './login';

const CircularProgressWrapper = cc(() => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

const PrivateRoute = ({
  component: Component,
  isFirebaseLoaded,
  isLoggedIn,
  ...rest
}) => {
  if (!isFirebaseLoaded) {
    return (
      <CircularProgressWrapper>
        <CircularProgress size={50} />
      </CircularProgressWrapper>
    );
  } else if (isFirebaseLoaded && !isLoggedIn) {
    return <Redirect to="/login" />;
  }
  return <Route {...rest} render={props => <Component {...props} />} />;
};

const Routes = ({
  store: {
    apiStore: { isLoggedIn, isFirebaseLoaded },
  },
}) => (
  <BrowserRouter>
    <React.Fragment>
      <Switch>
        <Route exact path="/login" component={Login} />
        <PrivateRoute
          path="/"
          component={Home}
          isFirebaseLoaded={isFirebaseLoaded}
          isLoggedIn={isLoggedIn}
        />
      </Switch>
    </React.Fragment>
  </BrowserRouter>
);

export default inject('store')(observer(Routes));



// WEBPACK FOOTER //
// ./src/routes/index.js